export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative border-t border-white/10 bg-[#05050A] py-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-2 font-heading font-black text-2xl text-white">
              <span className="inline-block w-3 h-3 bg-[#00F0FF] shadow-[0_0_15px_#00F0FF]" />
              $LA28 · LA28 ARMY
            </div>
            <p className="mt-3 text-white/45 font-mono text-xs tracking-[0.2em]">
              // COMMUNITY · CULTURE · COUNTDOWN
            </p>
          </div>
          <div className="font-mono text-xs tracking-[0.2em] text-white/40">
            © 2025 — 2028 · LA28 ARMY
          </div>
        </div>

        <div
          data-testid="footer-disclaimer"
          className="mt-12 pt-8 border-t border-white/10 text-center text-white/45 text-sm leading-relaxed max-w-4xl mx-auto"
        >
          <span className="font-mono text-[10px] tracking-[0.32em] text-[#FFD700] block mb-3">
            // DISCLAIMER
          </span>
          $LA28 and LA28 Army are independent community-driven meme projects
          created for entertainment and cultural purposes only. They are not
          affiliated with, endorsed by, or connected to the International
          Olympic Committee, LA28 organizing committee, or any official
          sporting body. This is not financial advice. Crypto involves risk —
          ape responsibly.
        </div>
      </div>
    </footer>
  );
}
